import { render, staticRenderFns } from "./footerView.vue?vue&type=template&id=7240682c&scoped=true"
import script from "./footerView.vue?vue&type=script&lang=js"
export * from "./footerView.vue?vue&type=script&lang=js"
import style0 from "./footerView.vue?vue&type=style&index=0&id=7240682c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7240682c",
  null
  
)

export default component.exports